import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface PagesState {
  transits: {
    elemsPerPage: number;
  };
  'task-manager': {
    elemsPerPage: number;
  };
  task: {
    elemsPerPage: {
      answers?: number;
      comments?: number;
    };
  };
  users: {
    elemsPerPage: number;
  };
  offers: {
    hideOfferPayouts: boolean;
    elemsPerPage: number;
  };
  offersManage: {
    elemsPerPage: {
      affiliates?: number;
      categories?: number;
    };
  };
}

type PageName = keyof PagesState;
type ElemsPerPageType<P extends PageName> = PagesState[P]['elemsPerPage'] extends object
  ? Partial<PagesState[P]['elemsPerPage']>
  : PagesState[P]['elemsPerPage'];

export const initialState: PagesState = {
  transits: {
    elemsPerPage: 10,
  },
  'task-manager': {
    elemsPerPage: 20,
  },
  task: {
    elemsPerPage: {
      answers: 10,
      comments: 10,
    },
  },
  users: {
    elemsPerPage: 20,
  },
  offers: {
    hideOfferPayouts: false,
    elemsPerPage: 50,
  },
  offersManage: {
    elemsPerPage: {
      affiliates: 10,
      categories: 10,
    },
  },
};

export const pagesSlice = createSlice({
  name: 'pages',
  initialState,
  reducers: {
    setElemsPerPage: <P extends PageName>(
      state: PagesState,
      action: PayloadAction<{ page: P; elemsPerPage: ElemsPerPageType<P> }>
    ) => {
      const { page, elemsPerPage } = action.payload;
      if (typeof elemsPerPage === 'number' && typeof state[page].elemsPerPage === 'number') {
        state[page].elemsPerPage = elemsPerPage;
      } else if (
        typeof elemsPerPage === 'object' &&
        typeof state[page].elemsPerPage === 'object' &&
        state[page].elemsPerPage !== null
      ) {
        state[page].elemsPerPage = {
          ...(state[page].elemsPerPage as object),
          ...elemsPerPage,
        };
      }
    },
    setHideOfferPayouts: (state: PagesState, action: PayloadAction<boolean>) => {
      state.offers.hideOfferPayouts = action.payload;
    },
  },
});

export const pagesReducer = pagesSlice.reducer;

export const { setElemsPerPage, setHideOfferPayouts } = pagesSlice.actions;
